import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import { setLanguageInLocalStorage } from "../../../hooks/useLanguagePercistant";
import { STRAPI_BASE_URL } from "../../../api/baseURL";
import LinkSelector from "../linkSelector/linkSelector";
import { useDispatch, useSelector } from "react-redux";
import { selectLoginTokenInfo } from "../../../redux/features/loginRegisterSlice";
import { performLogout } from "../../../utils/logoutHandler";
import { setLanguageTopic } from "../../../utils/pushLanguageTopic";
import SafeLink from "../../common/safeLink";

const Dropdown = ({ items, closeDropdown, onItemClick }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const loginInfo = useSelector(selectLoginTokenInfo);
  const translate = useLanguageTranslate();

  const logoutHandler = () => {
    performLogout({ dispatch, navigate });
  };

  const handleLanguageChange = () => {
    const switch_lang = i18n.resolvedLanguage === "ar" ? "en" : "ar";
    i18n.changeLanguage(switch_lang);
    setLanguageInLocalStorage(switch_lang);
    setLanguageTopic(switch_lang);
  };

  const onDropdownItemClick = (item, event) => {
    if (item.type === "logout") {
      logoutHandler();
      return;
    } else if (item.handleLangChng) {
      handleLanguageChange();
      return;
    }
    // For link rows, SafeLink handles navigation; we only close here for non-link items
    closeDropdown?.();
  };

  return (
    <div className="solidarity-dropdown-popup absolute right-0 mt-2 settings-box bg-white shadow-[0px_0px_1px_0px_rgba(26,32,36,0.32),0px_12px_24px_0px_rgba(91,104,113,0.24)] min-w-[272px] p-4 rounded-[10px] rtl:left-[0px] rtl:right-[unset]">
      <style>{`
        @keyframes solidarityDropdownIn {
          from { opacity: 0; transform: translateY(-6px) scale(0.96); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
        .solidarity-dropdown-popup {
          animation: solidarityDropdownIn 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
          transform-origin: top right;
          will-change: transform, opacity;
        }
        [dir="rtl"] .solidarity-dropdown-popup { transform-origin: top left; }
        @media (prefers-reduced-motion: reduce) {
          .solidarity-dropdown-popup { animation: none !important; }
        }
      `}</style>
      <ul className="py-1">
        {items.map((item, index) => {
          const imgSrc =
            typeof item.image === "object"
              ? translate(
                  item?.image?.img?.data?.attributes?.url,
                  item?.image?.arabic_img?.data?.attributes?.url ||
                    item?.image?.img?.data?.attributes?.url
                )
              : "";
          const finalImgUrl = `${STRAPI_BASE_URL}${imgSrc}`;

          const newItem = {
            ...item,
            icon: {
              data: typeof item.image === "object" ? finalImgUrl : item.icon,
              img_alt_en:
                typeof item.image === "object" ? item?.image?.img_alt_en : "",
              img_alt_ar:
                typeof item.image === "object" ? item?.image?.img_alt_ar : "",
            },
            label_en: item.text_en,
            label_ar: item.text_ar,
          };

          const isAction = item.type === "logout" || item.handleLangChng;
          const hasLink = Boolean(item.link);

          return (
            <li
              key={index}
              className={`px-4 py-3 hover:bg-gray-100 flex items-center text-[#48535B] text-sm not-italic font-normal leading-6 cursor-pointer relative p-2 ${
                item.showIfIsLoggedIn === true &&
                (loginInfo == null || loginInfo === "")
                  ? "hidden"
                  : ""
              } ${item.hide ? "hidden" : ""}`}
              onClick={(event) =>
                onItemClick
                  ? onItemClick(item, event)
                  : onDropdownItemClick(item, event)
              }
            >
              {/* If this is a link row, delegate click to SafeLink; otherwise render as before */}
              {hasLink && !isAction ? (
                <SafeLink
                  href={item.link}
                  isInternal={item.is_internal === true}
                  // allow native behavior for tel:/mailto:/whatsapp:
                  preferNativeAnchorForSpecial={true}
                  // close dropdown before navigating
                  onClick={() => closeDropdown?.()}
                  className="flex items-center w-full"
                >
                  <LinkSelector
                    item={newItem}
                    handleChange={closeDropdown}
                    ClassName={"flex items-center w-full"}
                  />
                </SafeLink>
              ) : (
                <LinkSelector
                  item={newItem}
                  handleChange={closeDropdown}
                  ClassName={"flex items-center w-full"}
                />
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Dropdown;
